import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.browse.query.gql"
import type {
  FeatureBrowseQuery,
  FeatureBrowseQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/compose/__types__/license.featureGroup.browse.query"

type Options = QueryHookOptions<FeatureBrowseQuery, FeatureBrowseQueryVariables>

export function useFeatureBrowseQuery(options?: Options) {
  return useQuery<FeatureBrowseQuery, FeatureBrowseQueryVariables>(
    query,
    options,
  )
}
